import { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { select, pointer } from "d3";

import Doughnut from "./Doughnut";

import GreenBars from "components/svg/GreenBars";

export default function ThermalEfficiency({ data, showBars }: any) {
  const thermalValue = 49;//data ? (data.consumedByFarm / (data.heatByCHP + data.heatByMiners)) * 100 : 0;

  const svgRef = useRef(null);
  const [width, setWidth] = useState(300);
  const [height, setHeight] = useState(300);

  const drawBackground = () => {
    // reset background size to defaults
    const contentBackground = select(svgRef.current).select(".contentBackground");
    contentBackground.attr("width", 120).attr("height", 40);

    // calculate new background size
    const tooltipContentElement = select(svgRef.current).select(".content").node() as SVGElement;
    if (!tooltipContentElement) return;

    const contentSize = tooltipContentElement.getBoundingClientRect();

    contentBackground.attr("width", contentSize.width + 10).attr("height", contentSize.height + 5);

    return contentSize;
  };

  const handleMouseOver = (e: any) => {
    select(svgRef.current).select(".tooltip").transition().duration(10).attr("display", "block");
  };
  const handleMouseMove = (e: any) => {
    const [x, y] = pointer(e);
    const tooltip = select(svgRef.current).select(".tooltip");
    // tooltip.select(".item-value").text(`${value.toFixed(0)}%`);
    // tooltip.select("circle").attr("fill", color);
    tooltip.transition().duration(10).attr("display", "block");
    const contentSize = drawBackground();

    const translateX = contentSize.width + x + 100 > width ? x + 80 - contentSize.width : x + 120;
    const translateY = contentSize.height + y + 140 > height ? y + 100 - contentSize.height : y + 110;

    tooltip.attr("transform", `translate(${translateX}, ${translateY})`);
  };

  const handleMouseOut = (e: any) => {
    select(svgRef.current).select(".tooltip").transition().duration(10).attr("display", "none");
  };

  return (
    <div className="output-card p-7">
      {showBars ? (
        <NavLink className="absolute right-3" to={`${process.env.PUBLIC_URL}/thermal-data`}>
          <GreenBars />
        </NavLink>
      ) : null}
      <div className="flex-shrink-0 px-3 font-bold">Thermal Efficiency</div>
      <div className="flex flex-col items-center">
        <div className="h-48 w-48 relative">
          <svg
            overflow="visible"
            className="cursor-crosshair"
            ref={(node) => {
              if (node) {
                const rect = node.getBoundingClientRect();
                setWidth(rect.width);
                setHeight(rect.height);
                svgRef.current = node;
              }
            }}
            viewBox={`0 0 ${width} ${height}`}
          >
            {data && !data.heatByCHP ? (
              <g>
                <rect rx={1} ry={1} width={width} height={height} fill="rgba(255, 255, 255, 0.75)" />
                <text fill="#5f698f" fontSize={24} transform="translate(-24, 92)">
                  No available data
                </text>
              </g>
            ) : (
              <>
                <g transform="translate(10, 10)">
                  <text
                    className="text-3xl text-gray-500 font-['Avenir-Bold']"
                    fill="#5f698f"
                    transform={`translate(${(width - 100) / 2},${height / 2})`}
                  >
                    {thermalValue ? thermalValue.toFixed(0) : 0}%
                  </text>
                  <Doughnut
                    x={(width - 20) / 2}
                    y={(height - 20) / 2}
                    innerRadius={Math.min(width - 20, height - 20) / 2 - 10}
                    outerRadius={Math.min(width - 20, height - 20) / 2}
                    color="#5676e9"
                    // value={
                    //   data
                    //     ? [
                    //         { value: data.heatByCHP, color: "#5676e9" },
                    //         { value: data.heatByMiners, color: "#2ac0d5" },
                    //         { value: data.destroyed, color: "#d1d5db" },
                    //       ]
                    //     : []
                    // }
                    value={data ? (data.heatByCHP / (data.heatByCHP + data.heatByMiners + data.destroyed)) * 100 : 0}
                    cornerRadius={15}
                    onMouseOver={handleMouseOver}
                    onMouseMove={handleMouseMove}
                    onMouseOut={handleMouseOut}
                  />
                  <Doughnut
                    x={(width - 20) / 2}
                    y={(height - 20) / 2}
                    innerRadius={Math.min(width - 20, height - 20) / 2 - 25}
                    outerRadius={Math.min(width - 20, height - 20) / 2 - 15}
                    color="#2ac0d5"
                    value={data ? (data.heatByMiners / (data.heatByCHP + data.heatByMiners + data.destroyed)) * 100 : 0}
                    cornerRadius={15}
                    onMouseOver={handleMouseOver}
                    onMouseMove={handleMouseMove}
                    onMouseOut={handleMouseOut}
                  />
                  <Doughnut
                    x={(width - 20) / 2}
                    y={(height - 20) / 2}
                    innerRadius={Math.min(width - 20, height - 20) / 2 - 40}
                    outerRadius={Math.min(width - 20, height - 20) / 2 - 30}
                    color="#757575"
                    value={data ? (data.destroyed / (data.heatByCHP + data.heatByMiners + data.destroyed)) * 100 : 0}
                    cornerRadius={15}
                    onMouseOver={handleMouseOver}
                    onMouseMove={handleMouseMove}
                    onMouseOut={handleMouseOut}
                  />
                </g>
                <g className="tooltip" display="none">
                  <rect
                    className="contentBackground"
                    rx={1}
                    ry={1}
                    fill="#fff"
                    strokeWidth={1}
                    stroke="#f0f0f0"
                    filter="drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.05))"
                  />

                  <g className="content">
                    {/* <text className="contentTitle" transform="translate(4,14)" /> */}
                    <g transform={`translate(1,8)`}>
                      {/* <circle r={6} fill="#5676e9" /> */}
                      <text className="item-value" transform="translate(1,4)" fill="#5676e9" fontSize="10">
                        CHP {data?.heatByCHP / 10 ** 6} MW
                      </text>
                    </g>
                    <g transform={`translate(1,22)`}>
                      {/* <circle r={6} fill="#2ac0d5" /> */}
                      <text className="item-value" transform="translate(1,4)" fill="#2ac0d5" fontSize="10">
                        <tspan x="0" dy="0.5em">
                          Miners {data?.heatByMiners / 10 ** 6} MW
                        </tspan>
                      </text>
                    </g>
                    <g transform={`translate(1,36)`}>
                      {/* <circle r={6} fill="#d1d5db" /> */}
                      <text className="item-value" transform="translate(1,4)" fill="#757575" fontSize="10">
                        <tspan x="0" dy="1em">
                          Destroyed {data?.destroyed / 10 ** 6} MW
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
              </>
            )}
          </svg>
        </div>
        <div className="w-full flex flex-wrap justify-between align-middle gap-2 mt-4 ml-5 text-xs">
          <div className="flex">
            <div className="rounded-full bg-blue-600 w-4 h-4 mr-2"></div>
            <div className="shrink">Created by CHP</div>
          </div>
          <div className="flex">
            <div className="rounded-full bg-cyan-600 w-4 h-4 mr-2"></div>
            <div className="shrink">Created by Miners</div>
          </div>
          <div className="flex">
            <div className="rounded-full border border-gray-300 bg-gray-100 w-4 h-4 mr-2"></div>
            <div className="shrink">Destroyed</div>
          </div>
        </div>
      </div>
    </div>
  );
}
